import type { PostDto, PostCreateDto, PostUpdateDto } from '@camper-diary/shared';
import { api } from './client';

export type Post = PostDto;

export function listPosts(tripId: string) {
  return api<Post[]>(`/trips/${encodeURIComponent(tripId)}/posts`);
}

export function createPost(tripId: string, input: PostCreateDto) {
  return api<Post>(`/trips/${encodeURIComponent(tripId)}/posts`, {
    method: 'POST',
    body: input,
  });
}

export function updatePost(tripId: string, id: string, input: PostUpdateDto) {
  return api<Post>(
    `/trips/${encodeURIComponent(tripId)}/posts/${encodeURIComponent(id)}`,
    { method: 'PATCH', body: input },
  );
}

export function deletePost(tripId: string, id: string) {
  return api<null>(
    `/trips/${encodeURIComponent(tripId)}/posts/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
  );
}
